import type { PredictionNavNode } from './types'

/**
 * Map a nav node's `filter` object to URL query params for the events API.
 * Filter values are already strings (spike S4). Returns a plain object; the
 * caller spreads it over the base queries (asset_type/limit/sort_by).
 * Example filters: {"asset_type":"sports"}, {"event_kind_groups":"<uuid>"},
 * {"event_kinds":"BTC,ETH"}, {"trending":"true"}, {"tags":"ec:fed"}.
 *
 * `live` 是 BE 特殊路由：`live=true` 不能与默认 asset_type=predicts 组合
 * （会查无数据，实测 stag 2026-09-02），所以 live 键本身不进 URL——由
 * predictionEventsInfiniteQueryOptions 对 live 节点额外加 `live: true` 参数。
 * 但 live 节点其余键（如 live 树的 `event_kind_groups`）保留：live 子分类
 * 查询 = `live=true + event_kind_groups=<uuid>`（实测 stag 2026-09-05 有效，
 * 与 cdc-web 对 live 键的处理一致——cdc-web 丢弃 live/trending 键、保留
 * event_kind_groups 等，见 knockOuts/utils/navFilterToEventParams.ts）。
 */
export function navFilterToEventParams(
  filter: PredictionNavNode['filter'],
): Record<string, string> {
  if (!filter) return {}
  const out: Record<string, string> = {}
  for (const [key, value] of Object.entries(filter)) {
    if (key === 'live') continue
    if (typeof value === 'string' && value.length > 0) out[key] = value
  }
  return out
}
